<div mat-dialog-content class="form-container" fxLayout="row">
  <div fxLayout="column">
    <mat-form-field appearance="fill">
      <mat-label>Comunidad</mat-label>
      <mat-select [(ngModel)]="idcomunidad" (selectionChange)="setComm($event)">
        <mat-option *ngFor="let comm of comunidades" [value]="comm.id">
          {{comm.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div ng2FileDrop
          (click)="fileInput.click()"
          [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
          (fileOver)="fileOverBase($event)"
          [uploader]="uploader"
          class="well my-drop-zone">
      <p>Pulse o arrastre los ficheros aquí</p>
    </div>
    <div *ngIf="uploader.queue.length > 0">
      <div class="file" *ngFor="let item of uploader.queue">
        {{item.file.name}}
      </div>
    </div>
    <button *ngIf="!uploading" mat-raised-button (click)="upload()">Importar</button>
    <input type="file" #fileInput style="display: none; height: 0px;" ng2FileSelect [uploader]="uploader" (change)="fileChanged($event)" />
    <button *ngIf="uploading" mat-raised-button disabled>Importando</button>
  </div>
</div>
